/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { API } from 'aws-amplify'
import "../../styles/containers/Login.scss";
import Grid from "@material-ui/core/Grid";
import logo from "../../assets/images/logo.png";
import BtnPrimary from "../../components/Button";
import TextInput from "../../components/TextInput";
import Dropdown from "../../components/Dropdown";
import { Formik } from "formik";
import { connect } from "react-redux";
import { loginValidation, resetPasswordValidation } from "../../validation";
import { getListOfParks } from "../../store/actions/parksActions";
import { login, completeNewPassword } from "../../service/AuthService";
import { login as loginAction } from "../../store/actions/auth";
import ForgotPassowrd from "./forgotPassword";
import { useHistory } from "react-router";
import { checkUserAPI } from "../../lib";
import { X_API_KEY } from "../../Constants";

function Login({ isFetched, parks, error, getListOfParks, loginAction }) {
  // const [parkHelperText, setParkHelperText] = useState(null);
  // const [parkTouched, setParkTouched] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [user, setUser] = useState({});
  const [parkOptions, setParkOptions] = useState([
    { value: "", label: "Select Park" },
  ]);
  // const [park, setPark] = useState(parkOptions[0]);
  const [loading, setLoading] = useState(false);
  const [errorMess, setErrorMess] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  let history = useHistory();

  const handleLogin = ({ email, password, park }) => {
    setLoading(true);
    API.get('AdminQueries', '/api/v1/checkuser', {
      queryStringParameters: {
        email: email,
        park_id: park.value,
      },
      headers: {
        "X-API-KEY": X_API_KEY,
      },
    })
      .then((res) => {
        if (res.message === true) {
          localStorage.setItem("park", JSON.stringify(park));
          login(email, password)
            .then((res) => {
              setLoading(false);
              setUser(res);
              if (res.challengeName) {
                setResetPassword(true);
                setErrorMess("");
                let userAttributes = res.challengeParam.userAttributes;
                const data = {
                  rights: userAttributes["custom:Rights"],
                  userName: `${userAttributes["custom:FirstName"]}  ${userAttributes["custom:LastName"]}`,
                  parkID: park.value,
                  userID: res.username,
                };
                loginAction(data);
                localStorage.setItem("userName", data.userName);
                localStorage.setItem("parkID", data.parkID);
                localStorage.setItem("userID", data.userID);
                localStorage.setItem("rights", data.rights);
              } else {
                const rights =
                  res?.signInUserSession?.accessToken?.payload[
                  "cognito:groups"
                  ][0];
                const data = {
                  rights,
                  userName: `${res.attributes["custom:FirstName"]} ${res.attributes["custom:LastName"]}`,
                  parkID: park.value,
                  userID: res.attributes.sub,
                };
                loginAction(data);
                localStorage.setItem("userName", data.userName);
                localStorage.setItem("parkID", data.parkID);
                localStorage.setItem("userID", res.attributes.sub);
                localStorage.setItem("rights", data.rights);
                history.push("/last-checkups");
              }
            })
            .catch((err) => {
              setErrorMess(err.message);
              setLoading(false);
            });
        } else {
          setErrorMess(res.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setErrorMess(
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err.message
        );
      });
  };

  useEffect(() => {
    if (error) setErrorMess(error);
  }, [error]);

  useEffect(() => {
    if (isFetched) {
      let options = [{ value: "", label: "Select Park" }];
      parks.map((park) =>
        options.push({
          value: park.id,
          label: park.name,
          number_of_carriers: park.number_of_carriers,
          number_of_elevator_carriers: park.number_of_elevator_carriers,
          number_of_towers: park.number_of_towers,
          position_of_flying_tower: park.position_of_flying_tower,
        })
      );
      setParkOptions(options);
    }
  }, [isFetched]);

  useEffect(() => {
    getListOfParks();
  }, []);

  const handleResetPassword = ({ password }) => {
    setLoading(true);
    completeNewPassword(user, password)
      .then(() => {
        history.push("/last-checkups");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMess(err.message);
        setLoading(false);
      });
  };

  const handleForgotPassword = (state) => {
    setForgotPassword(state);
  };

  const resetPasswordValues = { password: "", confirmPassword: "" };

  const initialValues = { email: "", password: "", park: "" };
  return (
    <div className="Login">
      <Grid container className="container">
        <Grid item xs={12} sm={5} elevation={6} className="form-space">
          <div className="logo-space">
            <img src={logo} alt="logo" className="logo" />
          </div>
          <Grid item xs={12} md={8} lg={7} className="form">
            {!resetPassword ? (
              !forgotPassword ? (
                <Formik
                  initialValues={initialValues}
                  validationSchema={loginValidation}
                  onSubmit={handleLogin}
                >
                  {({
                    handleChange,
                    setFieldTouched,
                    handleSubmit,
                    setFieldValue,
                    email,
                    touched,
                    password,
                    errors,
                  }) => {
                    const onInputChange = (name, e, type) => {
                      if (type === "dropdown") {
                        setFieldValue("park", e, true);
                      } else {
                        handleChange(e);
                        setErrorMess("");
                      }
                      setFieldTouched(name, true, false);
                    };
                    return (
                      <form noValidate onSubmit={handleSubmit}>
                        <div className="error-message">{errorMess}</div>
                        <Dropdown
                          placeholder="Select Park"
                          options={parkOptions}
                          onChange={(val) =>
                            onInputChange("park", val, "dropdown")
                          }
                          name="park"
                          id="park"
                          helperText={
                            touched.park && errors.park ? errors.park.value : ""
                          }
                        />
                        <TextInput
                          placeHolder="Email"
                          value={email}
                          helperText={touched.email ? errors.email : ""}
                          onChange={(e) => onInputChange("email", e)}
                          id="email"
                          type="email"
                          name="email"
                        />
                        <TextInput
                          placeHolder="Password"
                          type="password"
                          value={password}
                          helperText={touched.password ? errors.password : ""}
                          onChange={(e) => onInputChange("password", e)}
                          id="password"
                          name="password"
                        />
                        <div
                          className="forgot-password"
                          onClick={() => setForgotPassword(true)}
                        >
                          Forgot Password
                        </div>
                        <BtnPrimary
                          type="submit"
                          title="Login"
                          loader={loading}
                        />
                      </form>
                    );
                  }}
                </Formik>
              ) : (
                  <ForgotPassowrd handleForgotPassword={handleForgotPassword} />
                )
            ) : (
                <Formik
                  initialValues={resetPasswordValues}
                  validationSchema={resetPasswordValidation}
                  onSubmit={handleResetPassword}
                >
                  {({
                    handleChange,
                    setFieldTouched,
                    handleSubmit,
                    password,
                    confirmPassword,
                    touched,
                    errors,
                  }) => {
                    const onInputChange = (name, e) => {
                      handleChange(e);
                      setFieldTouched(name, true, false);
                    };
                    return (
                      <form onSubmit={handleSubmit}>
                        <div className="error-message">{errorMess}</div>
                        <TextInput
                          placeHolder="Password"
                          type="password"
                          value={password}
                          helperText={touched.password ? errors.password : ""}
                          onChange={(e) => onInputChange("password", e)}
                          id="password"
                          name="password"
                        />
                        <TextInput
                          placeHolder="Confirm Password"
                          type="password"
                          value={confirmPassword}
                          helperText={
                            touched.confirmPassword ? errors.confirmPassword : ""
                          }
                          onChange={(e) => onInputChange("confirmPassword", e)}
                          id="confirmPassword"
                          name="confirmPassword"
                        />
                        <BtnPrimary
                          type="submit"
                          title="Reset Password"
                          loader={loading}
                        />
                      </form>
                    );
                  }}
                </Formik>
              )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    parks: state.parks.parks,
    isFetched: state.parks.isFetched,
    error: state.parks.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getListOfParks: () => dispatch(getListOfParks()),
    loginAction: (data) => dispatch(loginAction(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
